export function formatDateTimeAsLocal(inDate: Date): string {
  return inDate.toLocaleString().replace(',', '');
}
const reDelLastZ = new RegExp('Z$');

export function isoDateTimeWithoutTZ(inDate: Date): string {
  return inDate.toISOString().replace(reDelLastZ, '')
}

export function getLocalHoursAndMinutesAsString(inDate: Date | null): string {
  if (!inDate) {
    return '';
  }
  const h = inDate.getHours();
  const m = inDate.getMinutes();
  return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}`;
}

export function getUTCHoursAndMinutesAsString(inDate: Date | null): string {
  if (!inDate) {
    return '';
  }
  const h = inDate.getUTCHours();
  const m = inDate.getUTCMinutes();
  return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}`;
}

export function correctDaysOfWeekByTimeZoneOnSave(dow: number[], time: Date | null): number[] {
  /*
  Время хранится в UTC, а вводится во временной зоне фронта. Из-за этого дни недели могут сдвигаться.
  Далее пример коррекции дня недели при сохранении (переводе из локального времени в UTC).
  Мск — Москва; Пп-К. — Петропавловск-Камчатский; AST — Атлантическое стандартное время
  ----------------------------------------------------------------------------------------------
    Смещение  | Локальное |  Локальный  | Время |День недели |            Правило
   лок.времени|   время   | день недели |  UTC  |    UTC     |
  ------------|-----------|-------------|-------|------------|----------------------------------
  +03:00 Мск  |   02:59   |     пт      | 23:59 |     чт     |
  +03:00 Мск  |   03:00   |     пт      | 00:00 |     пт     |
  +03:00 Мск  |   03:01   |     пт      | 00:01 |     пт     | смещение >= 0 &&
  ------------|-----------|-------------|-------|------------|   смещение > локального времени
  +12:00 Пп-К.|   11:59   |     пн      | 23:59 |     вс     |   => день недели смещается назад
  +12:00 Пп-К.|   12:00   |     пн      | 00:00 |     пн     |
  +12:00 Пп-К.|   12:01   |     пн      | 00:01 |     пн     |
  ------------|-----------|-------------|-------|------------|----------------------------------
  -04:00 AST  |   19:59   |     вс      | 23:59 |     вс     | смещение < 0 &&
  -04:00 AST  |   20:00   |     вс      | 00:00 |     пн     |   лок.время - 24:00 >= смещения
  -04:00 AST  |   20:01   |     вс      | 00:01 |     пн     |   => день недели смещается вперёд
  ----------------------------------------------------------------------------------------------
  */
  const timezoneOffsetInMinutes = -(new Date()).getTimezoneOffset();
  const timeInMinutes = time ? time.getHours() * 60 + time.getMinutes() : 0;
  if (timezoneOffsetInMinutes >= 0 && timezoneOffsetInMinutes > timeInMinutes) {
    // Восточное полушарие
    return dow.map((item) => item > 1 ? item - 1 : 7).sort();
  }
  if (timezoneOffsetInMinutes < 0 && timeInMinutes - 24 * 60 >= timezoneOffsetInMinutes) {
    // Западное полушарие
    return dow.map((item) => item < 7 ? item + 1 : 1).sort();
  }
  return dow.sort();
}

export function correctDaysOfWeekByTimeZoneOnLoad(dow: number[], time: Date): number[] {
  /*
  Время хранится в UTC, а вводится во временной зоне фронта. Из-за этого дни недели могут сдвигаться.
  Далее пример коррекции дня недели при загрузке (переводе из UTC в локальное время).
  Мск — Москва; Пп-К. — Петропавловск-Камчатский; AST — Атлантическое стандартное время
  ----------------------------------------------------------------------------------------------
    Смещение  | Время |День недели | Локальное |  Локальный  |            Правило
   лок.времени|  UTC  |    UTC     |   время   | день недели |
  ------------|-------|------------|-----------|-------------|----------------------------------
  +03:00 Мск  | 20:59 |     пт     |   23:59   |     пт      |
  +03:00 Мск  | 21:00 |     пт     |   00:00   |     сб      |
  +03:00 Мск  | 21:01 |     пт     |   00:01   |     сб      | смещение >= 0 &&
  ------------|-------|------------|-----------|-------------|   24:00 - UTC <= смещения
  +12:00 Пп-К.| 11:59 |     вс     |   23:59   |     вс      |   => день недели смещается вперёд
  +12:00 Пп-К.| 12:00 |     вс     |   00:00   |     пн      |
  +12:00 Пп-К.| 12:01 |     вс     |   00:01   |     пн      |
  ------------|-------|------------|-----------|-------------|----------------------------------
  -04:00 AST  | 03:59 |     вс     |   23:59   |     сб      | смещение < 0 &&
  -04:00 AST  | 04:00 |     вс     |   00:00   |     вс      |  UTC < модуль смещения
  -04:00 AST  | 04:01 |     вс     |   00:01   |     вс      |   => день недели смещается назад
  ----------------------------------------------------------------------------------------------
  */
  const timezoneOffsetInMinutes = -(new Date()).getTimezoneOffset();
  const utcTimeInMinutes = time.getUTCHours() * 60 + time.getUTCMinutes();
  if (timezoneOffsetInMinutes >= 0 && 24 * 60 - utcTimeInMinutes <= timezoneOffsetInMinutes) {
    // Восточное полушарие
    return dow.map((item) => item < 7 ? item + 1 : 1).sort();
  }
  if (timezoneOffsetInMinutes < 0 && utcTimeInMinutes < -timezoneOffsetInMinutes) {
    // Западное полушарие
    return dow.map((item) => item > 1 ? item - 1 : 7).sort();
  }
  return dow.sort();
}
